"use client";

import { c as _c } from "react/compiler-runtime";
import { useTimedState } from "@/hooks/use-timed-state";
import { copyText } from "@/lib/clipboard";
export const CONFIRMATION_MS = 2000;
export const DEMO_CONFIRMATION_MS = 1200;
export function useCopyState(t0) {
  const $ = _c(5);
  const resetMs = t0 === undefined ? CONFIRMATION_MS : t0;
  const [isCopied, setCopied] = useTimedState(false, resetMs);
  let t1;
  if ($[0] !== setCopied) {
    t1 = () => setCopied(true);
    $[0] = setCopied;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isCopied || $[3] !== t1) {
    t2 = {
      isCopied,
      markCopied: t1
    };
    $[2] = isCopied;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useCopyToClipboard(t0) {
  const $ = _c(5);
  const resetMs = t0 === undefined ? CONFIRMATION_MS : t0;
  const {
    isCopied,
    markCopied
  } = useCopyState(resetMs);
  let t1;
  if ($[0] !== markCopied) {
    t1 = async text => {
      const copied = await copyText(text);
      if (copied) {
        markCopied();
      }
      return copied;
    };
    $[0] = markCopied;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copy = t1;
  let t2;
  if ($[2] !== copy || $[3] !== isCopied) {
    t2 = {
      copy,
      isCopied
    };
    $[2] = copy;
    $[3] = isCopied;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}